var contactForm = (function () {

	function setup() {
		//$('#contact-form').on("click", "#submit-button", function (e) {
		//	var form = $(this).closest('form');
		//	$(form).fadeOut();
		//});
	}

	return {
		init: function () {
			$(function () {
				setup();
			});
		}
	};
})();

export var contactForm;